import Vue from 'vue';
import Vuex from 'vuex';
import snackbarNotification from '@/store/modules/snackbarNotification';
import registration from '@/store/modules/registration';
import auth from '@/store/modules/auth';
import resetPassword from '@/store/modules/resetPassword';
import poDetails from '@/store/modules/poDetails';
import poLookup from '@/store/modules/poLookup';
import myPOs from '@/store/modules/myPOs';
import employeesManagement from '@/store/modules/usersManagement/employees';
import suppliersManagement from '@/store/modules/usersManagement/suppliers';
import subordinatesWorkload from '@/store/modules/subordinatesWorkload';
import shippingLabelPage from '@/store/modules/shippingLabelPage';
import printLabel from '@/store/modules/printLabel';
import { abilityPlugin, ability as appAbility } from './ability';

Vue.use(Vuex);

export const ability = appAbility;

export const store = new Vuex.Store({
  plugins: [
    abilityPlugin,
  ],
  modules: {
    snackbarNotification,
    registration,
    auth,
    resetPassword,
    poDetails,
    myPOs,
    employeesManagement,
    suppliersManagement,
    subordinatesWorkload,
    poLookup,
    shippingLabelPage,
    printLabel,
  },
});
